import { useBoardEditingStore, useWallContentStore, type WallBoard } from '@walls/store';
import { AddClusterDialog } from './AddClusterDialog';
import { AddImageCardDialog } from './AddImageCardDialog';
import { AddTextCardDialog } from './AddTextCardDialog';
import { EditImageCardDialog } from './EditImageCardDialog';
import { EditTextCardDialog } from './EditTextCardDialog';
import { findCardById } from './utils/cardLookup';

interface CardActionOverlaysProps {
  board: WallBoard;
}

export function CardActionOverlays({ board }: CardActionOverlaysProps) {
  const editingMode = useBoardEditingStore((state) => state.editingMode);
  const editingCardId = useBoardEditingStore((state) => state.editingCardId);
  const cards = useWallContentStore((state) => state.cards);
  const card = findCardById(cards, editingCardId);

  if (editingMode === 'create-card') {
    return <AddTextCardDialog board={board} />;
  }

  if (editingMode === 'create-cluster') {
    return <AddClusterDialog board={board} />;
  }

  if (editingMode === 'add-image') {
    return <AddImageCardDialog board={board} />;
  }

  if (editingMode === 'edit-card' && card) {
    return <EditTextCardDialog board={board} card={card} />;
  }

  if (editingMode === 'edit-image' && card) {
    return <EditImageCardDialog board={board} card={card} />;
  }

  return null;
}
